import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ListGroup from 'react-bootstrap/ListGroup';
import { AlertSwal } from '../CustomSwal';
import { FormattedMessage, useIntl } from 'react-intl';

function DemeritList(props) {
  const [data, setData] = useState(null);
  const sid = sessionStorage.getItem('sid');
  const authid = sessionStorage.getItem('authid');
  const config = props.config;
  const intl = useIntl();

  const GetDemeritList = () => {
    props.setLoading(true);
    axios.get(config.API_URL + `/GetDemeritList.aspx`, {
      params: {
        sid: sid,
        authid: authid,
        restype: 'json'
      }
    }).then((res) => {
      const data = res.data[0];
      if (data.rescode === '3' || data.rescode === '4') {
        props.setSession(false);
      } else {
        if (data.rescode === '1') {
          if (data.resdata) {
            setData(data.resdata);
          } else {
            setData([]);
          }
        } else {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            text: intl.formatMessage({ id: 'global.failure' }),
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
          })
        }
      }
    }).catch((error) => {
      console.error(error)
    }).finally(() => {
      props.setLoading(false);
    })
  }

  useEffect(GetDemeritList, []);

  if (data === null) {
    return 'Loading';
  }

  return (
    <ListGroup variant="flush">
      <ListGroup.Item><b><FormattedMessage id='info.demeritlist' />：</b></ListGroup.Item>
      {
        data.map((row, index) => {
          return (
            <ListGroup.Item key={index} className='text-danger'>
              <span className='d-inline-block'><FormattedMessage defaultMessage={row.spacetypename} id={`global.spacetype.${row.spacetype}`} />-{row.devname}【{row.reason}】</span>
              <span className='d-inline-block'>{row.mdate}</span>
            </ListGroup.Item>
          )
        })
      }
      {data.length === 0 ? <ListGroup.Item><FormattedMessage id='info.list_empty'/></ListGroup.Item> : null}
    </ListGroup>
  )
}

export default DemeritList;